import axios from 'axios'
import React, {useEffect, useState} from 'react'
import LoadingOverlay from 'react-loading-overlay'

import './Productos.css'

function Productos() {
  const API_URL = process.env.REACT_APP_API_URL
  const [spinnerIsActive, setSpinnerIsActive] = useState(false)
  const [showAlertExcel, setShowAlertExcel] = useState(false)
  const [actionAlert, setActionAlert] = useState(null)

  useEffect(() => {
    if (!showAlertExcel) return undefined
    const timer = window.setTimeout(() => setShowAlertExcel(false), 5000)
    return () => window.clearTimeout(timer)
  }, [showAlertExcel])

  useEffect(() => {
    if (!actionAlert) return undefined
    const timer = window.setTimeout(() => setActionAlert(null), 5000)
    return () => window.clearTimeout(timer)
  }, [actionAlert])

  const uploadExcel = () => {
    const input = document.getElementById('file-carga-masiva')
    const data = new FormData()

    if (!input || input.files.length === 0) return

    setSpinnerIsActive(true)
    for (let i = 0; i < input.files.length; i++) data.append('file[]', input.files[i])

    axios.post(API_URL + '/carga-masiva', data, {}).then(
      () => {
        setSpinnerIsActive(false)
        setShowAlertExcel(Date.now())
      },
      (error) => {
        setSpinnerIsActive(false)
        setActionAlert({
          type: 'danger',
          message:
            error.response?.data?.message || 'No fue posible cargar el archivo de productos.',
        })
      }
    )
  }

  return (
    <>
      <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
        <div className='productos-management'>
          <div className='card card-custom shadow productos-card'>
            <div className='card-header productos-card-header'>
              <div>
                <h3 className='card-title'>Cargar productos (CSV)</h3>
                <p className='productos-card-description'>
                  Importa o actualiza productos en el catálogo mediante el archivo de carga.
                </p>
              </div>
            </div>
            <div className='card-body'>
              <div className='productos-action-row'>
                <div className='form-group productos-field'>
                  <label htmlFor='file-carga-masiva'>Archivo de productos:</label>
                  <input
                    id='file-carga-masiva'
                    type='file'
                    accept='.csv,.xlsx,.xls'
                    className='form-control'
                  />
                </div>
                <button
                  type='button'
                  className='btn btn-primary productos-action-button'
                  onClick={uploadExcel}
                >
                  Subir CSV
                </button>
              </div>
              <p className='productos-restrictions'>Formatos permitidos: CSV, XLSX o XLS.</p>
            </div>
          </div>
        </div>
      </LoadingOverlay>

      {showAlertExcel && (
        <div className='productos-page-alert alert alert-dismissible bg-primary d-flex flex-column flex-sm-row p-5 mb-10'>
          <div className='d-flex flex-column text-dark pe-0 pe-sm-10'>
            <h5 className='mb-1'>Archivo cargado</h5>
            <span>Los productos fueron procesados exitosamente.</span>
          </div>
          <button
            type='button'
            className='position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto'
            onClick={() => setShowAlertExcel(false)}
          >
            <span className='svg-icon svg-icon-2x svg-icon-light icon-close'>&#215;</span>
          </button>
        </div>
      )}

      {actionAlert && (
        <div
          className={`productos-page-alert alert alert-dismissible bg-${actionAlert.type} d-flex flex-column flex-sm-row p-5 mb-10`}
          role='alert'
        >
          <div className='d-flex flex-column text-dark pe-0 pe-sm-10'>
            <h5 className='mb-1'>Aviso</h5>
            <span>{actionAlert.message}</span>
          </div>
          <button
            type='button'
            className='position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto'
            onClick={() => setActionAlert(null)}
          >
            <span className='svg-icon svg-icon-2x svg-icon-light icon-close'>&#215;</span>
          </button>
        </div>
      )}
    </>
  )
}

export {Productos}
